/* eslint-disable import/prefer-default-export */
import PageWrapper from './PageWrapper';

export const wrapPageElement = PageWrapper;
